import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export default function DoneStep() {
  return (
    <div className="text-center py-8">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 20 }}
        className="w-16 h-16 rounded-full bg-[hsl(var(--success))/0.15] text-[hsl(var(--success))] flex items-center justify-center mx-auto mb-4"
      >
        <CheckCircle2 size={32} strokeWidth={1.75} />
      </motion.div>
      <p className="text-sm text-muted-foreground max-w-md mx-auto">
        Your Career OS is now personalized. Head to the Dashboard to see your first AI insights.
      </p>
    </div>
  );
}
